var _metadata, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMapleLeafIcon = function SvgMapleLeafIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsvg: "http://www.w3.org/2000/svg",
    viewBox: "0 0 728.96002 768",
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfrDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfabout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "\n                            image/svg+xml\n                        "), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,576 H 546.72 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,768)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.6367,130.7832)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    fill: "#B1282E",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 C 0,0 16.116,23.689 15.919,36.078 15.723,48.467 -112.5,145.291 -112.5,145.291 c 0,0 28.7,7.977 33.961,16.576 5.262,8.6 -14.858,79.959 -14.858,79.959 0,0 54.58,-14.492 77.475,-7.801 22.895,6.692 23.349,30.229 23.349,30.229 0,0 53.026,-73.527 60.494,-70.208 13.136,5.837 -33.961,152.117 -33.961,152.117 0,0 36.126,-22.007 50.945,-15.601 14.818,6.405 48.818,81.908 48.818,81.908 0,0 29.524,-72.913 45.637,-79.958 16.113,-7.045 54.127,13.651 54.127,13.651 0,0 -44.533,-145.837 -35.024,-151.142 9.51,-5.304 60.495,68.259 60.495,68.259 0,0 8.437,-16.943 21.226,-29.253 12.789,-12.31 76.415,6.826 76.415,6.826 0,0 -25.224,-57.68 -11.675,-77.033 13.549,-19.353 35.024,-20.478 35.024,-20.478 0,0 -126.225,-94.125 -128.419,-108.237 -1.381,-8.876 13.797,-38.029 13.797,-38.029 0,0 -112.622,19.738 -114.478,18.516 -1.855,-1.223 1.625,-131.629 1.625,-131.629 h -40.625 c 0,0 7.039,130.777 4.895,131.641 C 114.598,16.467 0,0 0,0"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapleLeafIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MapleLeafIcon.a2d8126f.svg";
export { ForwardRef as ReactComponent };